<template>
  <div class="area" :class="{ areaHeight: editMode }">
    <div v-if="!editMode" v-html="text" class="view" />
    <div v-show="editMode" class="textInput">
      <quill
        ref="quill"
        :id="id"
        @text-change="change"
        v-model="editorData"
        :prompt="prompt"
        :popontop="false"
        @focusout="save"
      />
    </div>
    <transition name="fade">
      <SaveButton v-if="editMode && modified && !admin" @save="save" class="save" />
    </transition>
  </div>
</template>

<script>
import SaveButton from "@/components/buttons/SaveButton";
import Quill from "@/components/util/Quill";

export default {
  name: "EditableArea",
  components: { quill: Quill, SaveButton },
  props: ["id", "text", "prompt", "edit", "admin"],

  mounted() {
    var tabHideEls = document.querySelectorAll(".ql-toolbar .ql-picker-label");
    tabHideEls.forEach(function(item) {
      item.setAttribute("tabindex", -1);
    });
  },

  data() {
    return {
      editorData: this.text,
      modified: false
    };
  },

  computed: {
    editMode: function() {
      return this.$parent.ownProfile || this.edit;
    }
  },

  watch: {
    text: function(newVal) {
      this.editorData = newVal;
    }
  },

  methods: {
    save: function() {
      if (this.modified == true) {
        this.modified = false;
        this.$emit("textChanged", this.editorData);
      }
    },

    change: function() {
      this.modified = true;
    },

    refresh() {
      if (this.$refs.quill) {
        this.$refs.quill.refresh();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.area {
  max-height: 162px;
  overflow: visible;
  display: grid;
  grid-template-rows: 1fr min-content;
  position: relative;

  .view {
    overflow-y: auto;
  }

  .save {
    position: absolute;
    top: -2px;
    right: 5px;
  }
}

.areaHeight {
  height: 162px;
}

.textInput div {
  height: 120px;
}
</style>
